import { render, staticRenderFns } from "./DestinationWorkEdit.vue?vue&type=template&id=55160caf&"
import script from "./DestinationWorkEdit.vue?vue&type=script&lang=js&"
export * from "./DestinationWorkEdit.vue?vue&type=script&lang=js&"
import style0 from "./DestinationWorkEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports